import assetPath from '/app/packages/lebenslauf/articles/src/assets/deckblatt-fuer-die-bewerbung-gestal.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')